import { render, staticRenderFns } from "./HabeasData.vue?vue&type=template&id=513bbb34"
import script from "./HabeasData.vue?vue&type=script&lang=js"
export * from "./HabeasData.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/mahalo_integrador/hiopos/reports-co/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('513bbb34')) {
      api.createRecord('513bbb34', component.options)
    } else {
      api.reload('513bbb34', component.options)
    }
    module.hot.accept("./HabeasData.vue?vue&type=template&id=513bbb34", function () {
      api.rerender('513bbb34', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/app/public/HabeasData.vue"
export default component.exports